<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Pontos de Venda | Criação" :on-back="back" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-point-of-sale @submit="($model: PointOfSale) => submit($model)" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script setup lang="ts">
import FormPointOfSale from '@/views/point_of_sales/form-point-of-sale.vue'
import type PointOfSale from '@/types/PointOfSale'
import TPageTitle from '@/components/TPageTitle.vue'
import PointOfSaleService from '@/services/PointOfSaleService'
import { useRouter } from 'vue-router'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'

const loader = useLoader()
const router = useRouter()
const snackbar = useSnackBar()

function back() {
  router.push('/points-of-sale')
}

async function submit(model: PointOfSale) {
  loader.increment()

  try {
    await new PointOfSaleService().store(model)
    snackbar.show('Ponto de venda criado', 'success')
    router.push({ name: 'create-point-of-sale' })
  } finally {
    loader.decrement()
  }
}
</script>
